export function redirectToBeastModeEscalation() {
  window.location.assign(`/settings/escalate?redirect=${encodeURIComponent(window.location.pathname)}`);
}
